const alertFollowUpHeader = [
  {
    group: 'General',
    columns: [
      {
        name: 'Id',
        id: 'general-id',
        show: false
      },
      {
        name: 'Centro',
        id: 'general-centro',
        show: true
      },
      {
        name: 'Código do Fornecedor',
        id: 'general-codigo-fornecedor',
        show: true
      },
      {
        name: 'Código do Produto',
        id: 'general-codigo-do-produto',
        show: true
      },
      {
        name: 'Nome do Produto',
        id: 'general-nome-do-produto',
        show: true
      },
      {
        name: 'Data Estimada',
        id: 'general-data-estimada',
        show: true
      },
      {
        name: 'Data Revisada',
        id: 'general-data-revisada',
        show: true
      },
      {
        name: 'A Fornecer',
        id: 'general-a-fornecer',
        show: true,
        isNumeric: true
      },
      {
        name: 'A Fornecer Revisado',
        id: 'general-a-fornecer-revisado',
        show: true,
        isNumeric: true
      },
      {
        name: 'A Fornecer R$',
        id: 'general-a-fornecer-rs',
        show: true,
        isNumeric: true
      },
      {
        name: 'Total Pedido',
        id: 'general-total-pedido',
        show: true,
        isNumeric: true
      },
      {
        name: 'Status Entrega',
        id: 'general-status-entrega',
        show: true
      },
      {
        name: 'Data Faturamento Pedido',
        id: 'general-data-faturamento-pedido',
        show: true
      },
      {
        name: 'Ruptura 0 Dias',
        id: 'general-ruptura-zero',
        show: true,
        isNumeric: true
      },
      {
        name: 'Ruptura 10 Dias',
        id: 'general-ruptura-ten',
        show: true,
        isNumeric: true
      },
      {
        name: 'Ação',
        id: 'general-acao',
        show: true
      },
      {
        name: 'Historico',
        id: 'general-histórico',
        show: true
      }
    ]
  }
]

export default alertFollowUpHeader
